module.exports = __webpack_public_path__ + "img/m_brandstory_img01.96123fcf.jpg";